export const environment = {
	production: true,
	gtmPruebas: false,
	envName: 'master',
	clientId: 'AvI7MZug3dyIZk1JGFNDm+JOX28ruCgtA9I6d71C4Wg=',
	domain: 'midatacredito.com',
 	datadog: true,
	// OptinMonster: solo habilitar en ambientes cuyo dominio este registrado en la cuenta
	optinMonster: {
		enabled: true,
		userId: 285762,
		accountId: 303730,
	},
	APIEndpoint_nwuser: 'https://buscacredito.midatacredito.com/nwuser-ws',
	APIEndpoint_ldnfosession: 'https://buscacredito.midatacredito.com/ldnfosession-ws',
	APIEndpoint_bank: 'https://buscacredito.midatacredito.com/bank-ws',
	APIEndpoint_authn: 'https://buscacredito.midatacredito.com/authn-ws',
	APIEndpoint_ngttion: 'https://buscacredito.midatacredito.com/ngttion-ws',
	APIEndpoint_vpce_ws: 'vpce-ws',

	urlLogin: 'https://usuario.midatacredito.com/login?product=bc',
	urlRegister: 'https://usuario.midatacredito.com/registro?product=bc',
	urlProfile: 'https://usuario.midatacredito.com/private/perfil?product=bc',
	urlMIDC: 'https://www.midatacredito.com/',
	urlIpify: 'https://api.ipify.org?format=json',

	// CloudFront
	enlaces_cloudFront: {
		url: 'https://d3667p9n8t6zw1.cloudfront.net/',
		bcPath: 'Buscacredito/produccion',
		terminos_condiciones: 'tyc/terminos_y_condiciones.pdf',
		politica_privacidad: 'tyc/politica_de_tratamiento_de_datos_personales.pdf',
		allLogos: 'assets/prod/allLogos.json'
	},

	Auth: {
		validateSession: '/authn/validateSession',
		logOff: '/authn/signOff'
	},
	InfoSession: {
		ecs: '/sessioninfo/ecs'
	},
	Bank: {
		offersListHome: '/ecs/datacash/bank/v2/homeOffers',
		offersListFree: '/ecs/datacash/bank/v1/freeOffers',
		offers: '/ecs/datacash/bank/v1/userOffers',
		offersPreselecta: '/ecs/datacash/bank/v1/userOffersPreselecta',
		offerDetail: '/ecs/datacash/bank/v1/userOfferDetail',
		offerDetailFree: '/ecs/datacash/bank/v1/freeOfferDetail',
		aplicarOferta: '/ecs/datacash/bank/v1/applyOffer',
		applyOfferPreselecta: '/ecs/datacash/bank/v1/applyOfferPreselecta',
		appliedUserOffer: '/ecs/datacash/bank/v1/appliedUserOffer',
		offerHistory: '/ecs/datacash/bank/v1/requesthistory',
		saveOfferEvent: '/ecs/datacash/bank/v1/saveOfferEvent',
		campaignInfo: '/ecs/datacash/bank/v1/campaigninfo',
		customercampaigninfo: '/ecs/datacash/bank/v1/customercampaigninfo',
		applyCampaign: '/ecs/datacash/bank/v1/campaign',
		historyAppliedOffer: '/ecs/datacash/bank/v1/historyAppliedOffer',
		experienceEvaluation: '/ecs/datacash/bank/v1/experienceEvaluation',
		aplicarOfertaDav: '/ecs/datacash/bank/v1/davivienda',
		pagadurias: '/intgrtn/util/pagadurias',
		wasticredit: '/intgrtn/wasticredit',
		softFilters: '/ecs/datacash/bank/v1/soft/filters',
		registerOfferAbandonment: '/ecs/datacash/bank/v1/registerOfferAbandonment',
		categoriesBC: '/api/config/buscacredito/categories/getAll'
	},
	NewUser: {
		updateProfile: '/new-user-ws/api/v1/user/updateProfile',
		addCustomerLog: '/termsConditions/addCustomerLog',
	},
	Negotiation: {
		createValidation: '/autentication/customer/createValidation',
		validation: '/autentication/customer/validation'
	},
	banners: {
		getBanner: '/banners/getBannerNow/BUSCACREDITO'
	},
	cloudFrontBc: {
		categorias: '/categorias.json',
		filter: '/filter.json',
		nitPreselecta: '/nitPreselecta.json'
	},
	country: 'CO',
	slotsBanners: {
		home: '/22857899675/Ad_Unit_BC_Home',
		categorias: '/22857899675/Ad_Unit_BC_Categoria',
		ofertas: '/22857899675/Ad_Unit_BC_Ofertas',
		faq: '/22857899675/Ad_Unit_BC_Faq',
		lista_ofertas_1: '/22857899675/Test_Ad_Unit_BC_Ofertas02',
		lista_ofertas_2: '/22857899675/Test_Ad_Unit_BC_Ofertas03',
	},
	conectaBancolombia: {
		customersValidate: "/prd/customers/validate",
		customersAuthenticate: "/prd/customers/authenticate",
		termsRetrieve: "/prd/terms/retrieve",
		termsRegister: "/prd/terms/register",
		decline: "/prd/decline",
		enableOffersPreapproved: "/prd/enable-offers/preapproved",
		simulations: "/prd/simulations",
		accountsRetrieve: "/prd/accounts/retrieve",
		disbursementsConfirm: "/prd/disbursements/confirm",
		customersSignDocument: "/prd/customers/eSignDocument",
		customersSigningCode: "/prd/customers/signingCode",
		disbursements: "/prd/disbursements",
		validateCreditStudy: "/prd/validate-credit-study",
		disbursementsStatus: "/prd/disbursements/status",
	},
	headersBancolombia: {
		'Content-Type': 'application/json',
		'x-apigw-api-id': 'w8jcqvezg7'
	},

	//Endpoint para dataDog
	 APIEndPoints: {
		 urlEndPoints: 'https://dev-o-midc-a13-ui.internal.midc.dev.ecs.us.coaas.net/',
		 loadParameters: '/ldnfosession/load-parameter/byKeyApp'
	 }
};